import React from "react";
import PageNotFound from "@mnemonic/mui5/PageNotFound";
import { Swagger } from "../Pages/Swagger";
import { logRoute } from "./interceptors";
const PageNotFoundComponent = () => (<div style={{ marginTop: "64px" }}>
    <PageNotFound contact="mss@mnemonic.no"/>
  </div>);
export const routeDefinitions = [
    { path: "", component: Swagger, interceptors: [logRoute()] },
    { path: "/*", component: PageNotFoundComponent, interceptors: [logRoute()] },
];
